import { RootState } from "../../../redux-store";
import { createSelector } from "@reduxjs/toolkit";

export const selectRouteLogin = (routeId: string) => (state: RootState) => {
  return state.data.driverActivities.byRouteId[routeId];
};

export const selectCompletedStopFromActivities =
  (stopId: string) => (state: RootState) => {
    return state.data.driverActivities.completedStops[stopId];
  };

export const selectArrivedStopFromActivities =
  (stopId: string) => (state: RootState) => {
    return state.data.driverActivities.arrivedStops[stopId];
  };

export const selectDepartedStopFromActivities =
  (stopId: string) => (state: RootState) => {
    return state.data.driverActivities.departedStops[stopId];
  };

/**
 * It will return complete even if the stop only has departed, but not picked up / dropped off
 * @param stopId
 */
export const selectRouteStopStatus = (stopId: string) =>
  createSelector(
    selectCompletedStopFromActivities(stopId),
    selectArrivedStopFromActivities(stopId),
    selectDepartedStopFromActivities(stopId),
    (completedStop, arrivedStop, departedStop) => {
      return completedStop || departedStop
        ? "complete"
        : arrivedStop
          ? "in-progress"
          : null;
    }
  );
